import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CollapseIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M7.00781 3.01562V5.59375L3.41406 2L2 3.41406L5.60156 7.01562H3.00781V9.01562H9.00781V3.01562H7.00781Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7.00781 21V18.4219L3.41406 22.0156L2 20.6016L5.60156 17H3.00781V15H9.00781V21H7.00781Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 3.01562V5.59375L20.5938 2L22.0078 3.41406L18.4062 7.01562H21V9.01562H15V3.01562H17Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 21V18.4219L20.5938 22.0156L22.0078 20.6016L18.4062 17H21V15H15V21H17Z",
    fill: "currentColor"
  }));
}